const translations: Record<string, string> = {
  "ak_tr_mwh": "MWh",
  "ak_tr_uah_mwh_actual": "UAH · {{n}} MWh actual",
  "ak_tr_d": "d",
  "ak_tr_dam_weighted": "DAM weighted",
  "ak_tr_idm_weighted": "IDM weighted",
  "ak_tr_dam_volume": "DAM volume",
  "ak_tr_dam_price": "DAM price",
  "ak_tr_idm_price": "IDM price",
  "ak_tr_oree_dam_weighted": "OREE DAM weighted",
  "ak_tr_oree_idm_weighted": "OREE IDM weighted",
  "ak_tr_ueex_base_realized": "UEEX BASE realized",
  "ak_tr_actual_generation_mwh": "Actual generation, MWh",
  "ak_tr_potential_revenue_uah_dam_actual": "Potential revenue, UAH (DAM × actual)",
  "ak_tr_7d_avg": "7d avg:",
  "ak_tr_mwh_actual": "{{n}} MWh actual",
  "ak_tr_days": "{{n}} days",
  "ak_tr_dam_uah_mwh": "DAM, UAH/MWh",
  "ak_tr_idm_uah_mwh": "IDM, UAH/MWh",
  "ak_tr_oree_dam": "OREE DAM",
  "ak_tr_oree_idm": "OREE IDM",
  "ak_tr_actual_generation_mwh_2": "Actual generation, MWh",
  "ak_tr_potential_revenue_uah": "Potential revenue, UAH",
  "ak_tr_loading": "Loading…",
  "ak_tr_dam": "DAM",
  "ak_tr_idm": "IDM",
  "ak_tr_ueex_base": "UEEX BASE",
  "ak_tr_actual_generation": "Actual generation",
  "ak_tr_potential_revenue": "Potential revenue",
  "ak_tr_uah": "UAH",
};

export default translations;
